import AuthorizationProvider from "./AuthorizationProvider";
import ColorSchemeProvider from "./ColorSchemeProvider";
import FeatureFlagProvider from "./FeatureFlagProvider";
import GraphqlProvider from "./GraphqlProvider";
import { InitializeRaygunUser } from "./RaygunProvider";
import AuthenticationProvider from "./AuthenticationProvider";
import AmplitudeProvider from "./AmplitudeProvider";
import AmplitudeAffiliationIdentify from "./AmplitudeProvider/AmplitudeAffiliationIdentify";
import ProcessTrackerProvider from "./ProcessTrackerProvider";
import AssumeUserProvider, { useAssumeUser } from "./AssumeUserProvider";
import useCurrentUser from "@/hooks/useCurrentUser";

type Props = {
  children: React.ReactNode;
};

function AssumedUserSessionProviders({ children }: Props): React.ReactNode {
  const { user } = useCurrentUser();
  const authenticatedUserSub = user.sub;
  const { authorizationSubjectId, sessionKey } = useAssumeUser();
  const impersonationScope = authorizationSubjectId ?? "actor";
  const graphqlSessionKey = `${authenticatedUserSub}:${sessionKey}`;

  return (
    <AmplitudeProvider>
      <GraphqlProvider key={graphqlSessionKey}>
        <AuthorizationProvider key={`${authenticatedUserSub}:${impersonationScope}`}>
          <AmplitudeAffiliationIdentify />
          <FeatureFlagProvider>
            <ColorSchemeProvider>
              <ProcessTrackerProvider>
                <InitializeRaygunUser />
                {children}
              </ProcessTrackerProvider>
            </ColorSchemeProvider>
          </FeatureFlagProvider>
        </AuthorizationProvider>
      </GraphqlProvider>
    </AmplitudeProvider>
  );
}

export default function Providers({ children }: Props): React.ReactNode {
  return (
    <AuthenticationProvider>
      <AssumeUserProvider>
        <AssumedUserSessionProviders>{children}</AssumedUserSessionProviders>
      </AssumeUserProvider>
    </AuthenticationProvider>
  );
}
